import { useContext } from 'react';
import { PushNotificationContext, PushNotificationContextType } from '../components/atomic/PushNotificationProvider';

export function usePushNotifications() {
  return useContext(PushNotificationContext) as PushNotificationContextType;
}
